import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { INTERESTS as I } from "../lib/nav";
import { WATER } from "../lib/nav";
import { Sig } from "./Brand";

const ROW1 = [
  { eyebrow: "Advisory", key: I.advisory, subs: ["Strategic Advisory", "Business Development", "Brand Visibility"] },
  { eyebrow: "Agency", key: I.experiences, subs: ["Immersive travel", "Longevity, leisure, lifestyle", "Enhanced experiences"] },
  { eyebrow: "Assembly", key: I.connectivity, subs: ["The LIST (B2B)", "The LOUNGE (women only)", "The LIFESTYLE (elite only)", "The LEGACY (Cultural Celebrations & Family Investments)"] },
];
const ROW2 = [
  { key: I.wellthspan, subs: ["An in-depth audit and analysis of individual flourishing and organizational health, scored on the WELLTHSPAN™ Index. Early access coming soon."] },
  { key: I.speaking, subs: ["Keynotes, seminars and workshops with Nitasha Sarin, Founder & CEO, LUXEWELL."] },
  { key: "Signature Immersions", subs: ["Strategic Sabbaticals™", "Regenerative Retreats™", "Wellness Weddings™", "New dates coming soon · by application only"] },
];

export default function InviteModal({ open, onClose, defaultInterests = [] }) {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const [interests, setInterests] = useState([]);
  const [agree, setAgree] = useState(false);
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);
  useEffect(() => { document.body.classList.toggle("invite-open", !!open); return () => document.body.classList.remove("invite-open"); }, [open]);

  useEffect(() => {
    if (open) {
      setInterests(defaultInterests); setErr(""); setAgree(false); setDone(false);
      setFirstName(""); setLastName(""); setEmail(""); setPhone(""); setMessage("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  if (!open) return null;
  const toggle = (i) => setInterests((p) => (p.includes(i) ? p.filter((x) => x !== i) : [...p, i]));
  const submit = async (e) => {
    e.preventDefault();
    if (!firstName || !lastName || !email) { setErr("First name, last name and work email are required."); return; }
    if (!agree) { setErr("Please accept the Privacy Notice to continue."); return; }
    try {
      await api.post("/leads", { first_name: firstName, last_name: lastName, email, phone, message, interests, source_page: window.location.pathname });
      setDone(true);
    } catch { setErr("Something went wrong. Please try again."); }
  };

  const field = "w-full bg-white/10 border border-white/45 px-4 py-3 text-sm text-white outline-none focus:border-white mb-3 placeholder:text-white/75";
  const box = (o, idx) => (
    <div key={o.key + idx} className="text-white">
      {o.eyebrow && <p className="eyebrow !text-[0.55rem] gold-text font-semibold mb-1.5 [text-shadow:0_0_8px_rgba(226,184,103,0.6)]">{o.eyebrow}</p>}
      <label className="flex items-start gap-2.5 text-sm cursor-pointer">
        <input type="checkbox" data-testid={`invite-interest-${idx}`} checked={interests.includes(o.key)} onChange={() => toggle(o.key)} className="accent-[#B0823F] w-4 h-4 shrink-0 mt-0.5" />
        <span><Sig>{o.key}</Sig></span>
      </label>
      <ul className="mt-1.5 pl-6 space-y-0.5">{o.subs.map((s) => <li key={s} className="text-[0.72rem] text-white/80 leading-snug">· <Sig>{s}</Sig></li>)}</ul>
    </div>
  );
  return (
    <div className="invite-gold fixed inset-0 z-[60] flex items-center justify-center p-4" data-testid="invite-modal">
      <div className="absolute inset-0 bg-ink/70 backdrop-blur-sm" onClick={onClose} />
      <div className={`footer-pop relative w-full ${done ? "max-w-lg outline outline-1 outline-white/80 -outline-offset-[7px]" : "max-w-3xl"} text-white border border-gold/70 max-h-[90vh] overflow-auto bg-cover bg-center`} style={{ backgroundImage: `url(${WATER})` }}>
        <div className="absolute inset-0 bg-[#46603c]/[0.12] pointer-events-none" />
        <div className="relative p-8 lg:p-10">
          <button onClick={onClose} data-testid="invite-close" aria-label="Close" className="absolute top-4 right-6 text-white/80 hover:text-white text-2xl leading-none">×</button>
          {done ? (
            <div className="text-center py-10 flex flex-col items-center" data-testid="invite-thanks">
              <p className="font-display text-3xl">Thank you &</p>
              <p className="font-headline italic text-xl mt-2">Welcome to the House of</p>
              <img src="https://customer-assets-wrfwihn1.emergentagent.net/job_luxewell-eval/artifacts/v2uaire0_LUXEWELL%20LOGO%20%2813%29.png" alt="LUXEWELL" className="no-grade h-24 w-auto object-contain mt-2" data-testid="invite-thanks-logo" />
              <button onClick={() => { onClose(); navigate("/"); }} data-testid="invite-explore" className="btn-gold eyebrow !text-[0.62rem] px-6 py-3 mt-6 outline outline-1 outline-white/90 -outline-offset-[5px]">Explore the House</button>
              <p className="mt-6 text-sm text-white/90">Your invitation request has been submitted.</p>
              <p className="mt-1 text-sm text-white/90">Team LUXEWELL will be in touch within 48 hours.</p>
            </div>
          ) : (
          <form onSubmit={submit}>
            <div className="border border-white/50 p-4 -mx-4" data-testid="invite-frame">
            <div className="flex items-start justify-between gap-4 mb-6">
              <img src="https://customer-assets-wrfwihn1.emergentagent.net/job_luxewell-eval/artifacts/v2uaire0_LUXEWELL%20LOGO%20%2813%29.png" alt="LUXEWELL" className="no-grade h-20 w-auto object-contain -mt-2" data-testid="invite-logo" />
              <div className="text-right pt-6">
                <div className="relative inline-block mt-6">
                  <p className="absolute left-[3%] -top-1 eyebrow !text-[0.6rem] gold-text font-semibold whitespace-nowrap [filter:drop-shadow(0_1px_1.5px_rgba(8,16,8,0.5))_drop-shadow(0_0_8px_rgba(8,16,8,0.35))]" data-testid="invite-eyebrow">Enter the House</p>
                  <h3 className="font-sign lowercase text-4xl text-white" data-testid="invite-title">your invitation</h3>
                </div>
              </div>
            </div>
            <div className="grid sm:grid-cols-2 gap-x-3">
            <input data-testid="invite-firstname" required value={firstName} onChange={(e) => setFirstName(e.target.value)} placeholder="First name *" className={field} />
            <input data-testid="invite-lastname" required value={lastName} onChange={(e) => setLastName(e.target.value)} placeholder="Last name *" className={field} />
            <input data-testid="invite-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Work email *" className={field} />
            <input data-testid="invite-phone" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Phone (optional)" className={`${field} mb-5`} />
            </div>
            <div className="space-y-6" data-testid="invite-options-box">
              <div className="grid sm:grid-cols-3 gap-5">{ROW1.map((o, i) => box(o, i))}</div>
              <div className="grid sm:grid-cols-3 gap-5 pt-5 border-t border-white/25">{ROW2.map((o, i) => box(o, i + 3))}</div>
            </div>
            </div>
            <div className="border border-white/50 p-4 -mx-4 mt-6" data-testid="invite-report-box">
            <p className="text-xs text-white leading-relaxed mb-4" data-testid="invite-report-line">Every Guest of the House also receives <em>The LUXEWELL Report</em>, our weekly insider briefing on the six pillars of luxury wellness: the people, practitioners, places, properties, products and programmes shaping the industry — with interviews and our strategic insights, every Tuesday.</p>
            <textarea data-testid="invite-message" value={message} onChange={(e) => setMessage(e.target.value)} rows={3}
              placeholder="Anything you'd like us to know? (where we met, what you're looking for)" className={`${field} resize-none mb-5`} />
            <label className="flex items-start gap-3 text-xs text-white cursor-pointer mb-5">
              <input type="checkbox" data-testid="invite-consent" checked={agree} onChange={() => setAgree((v) => !v)} className="accent-[#B0823F] w-4 h-4 shrink-0 mt-0.5" />
              <span>I agree to receive emails from LUXEWELL and accept the <Link to="/privacy" target="_blank" className="text-white underline underline-offset-2 decoration-gold">Privacy Notice</Link>.</span>
            </label>
            {err && <p className="text-sm text-red-200 mb-3" data-testid="invite-error">{err}</p>}
            <button type="submit" data-testid="invite-submit" className="btn-gold btn-lux w-full text-center outline outline-1 outline-white/90 -outline-offset-[5px]">Receive your invitation</button>
            </div>
          </form>
          )}
        </div>
      </div>
    </div>
  );
}
